"use client";

import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import dynamic from "next/dynamic";
import { LATEST_DROP_TEXT, settings, TAMARA_SECTION_TITLE } from "./constants";
import {
    CUSTOM_PRIMARY_BUTTON_CLASS,
    IMAGE_CONTAINER_CLASS,
    TESTIMONIAL_BUTTON_CONTAINER,
    TESTIMONIAL_INNER_CONTAINER_ONE,
    TESTIMONIAL_INNER_CONTAINER_TWO,
} from "./Style";

import {
    SIGN_UP_ENDPOINT,
    SURVEY_START_SECTIONS,
} from "../../../public/Constants/EnumConstants";
import { BANNER_BUTTON_ID_TEXT } from "../../Molecules/NewBannerSection/constants";
import { FRONTEND_ENDPOINTS } from "../../../public/Constants/endpoints";
import NewPrimaryButtonWrapper from "../../Atoms/Buttons/NewPrimaryButtonWrapper";
import { GoogleTagManagerEvents } from "../../../common";

import ShoppableVideoCard from "../../Molecules/ShoppableVideoCard";
import { useIntersectionObserver } from "@uidotdev/usehooks";
const SectionHeading = dynamic(
    () => import("../../Atoms/Typography/SectionHeading")
);
const SessionDescription = dynamic(
    () => import("../../Atoms/Typography/SessionDescription")
);
const ShopTheLookCarrouselSection = ({ data }) => {
    const [loadComponent, setLoadComponent] = useState(false);
    const [visibleSlides, setVisibleSlides] = useState(new Set([0, 1, 2, 3]));

    const [ref, entry] = useIntersectionObserver({
        threshold: 0,
        root: null,
        rootMargin: "0px",
    });

    const modifiedSettings = {
        ...settings,
        beforeChange: (current, next) => {
            const totalSlides = data?.primary?.products?.length || 0;
            const newVisibleSlides = new Set();

            const slidesToLoad = window?.innerWidth < 768 ? 2 : 4; // Adjust for mobile view

            // Add current visible slides
            for (let i = next; i < next + slidesToLoad; i++) {
                newVisibleSlides.add((i + totalSlides) % totalSlides);
            }

            newVisibleSlides.add((next - 1 + totalSlides) % totalSlides); // Previous slide
            newVisibleSlides.add((next + slidesToLoad) % totalSlides); // Next slide

            setVisibleSlides(newVisibleSlides);
        },
    };

    useEffect(() => {
        if (entry?.isIntersecting) setLoadComponent(true);
    }, [entry?.isIntersecting]);

    const shouldLoadCard = (index) => {
        return visibleSlides.has(index);
    };

    const buttonHref =
        data?.primary?.title[0].text === TAMARA_SECTION_TITLE
            ? FRONTEND_ENDPOINTS?.TAMARA
            : SIGN_UP_ENDPOINT;

    useEffect(() => {
        if (entry?.isIntersecting) setLoadComponent(true);
    }, [entry?.isIntersecting]);

    return (
        <div ref={ref}>
            {loadComponent && (
                <>
                    <div className={TESTIMONIAL_INNER_CONTAINER_ONE}>
                        <SectionHeading text={data?.primary?.title} />
                        <SessionDescription text={data?.primary?.description} />
                    </div>
                    <div className={TESTIMONIAL_INNER_CONTAINER_TWO}>
                        <Slider {...modifiedSettings} lazyLoad={true}>
                            {data?.primary?.products?.map((item, index) => (
                                <ShoppableVideoCard
                                    key={index}
                                    item={
                                        shouldLoadCard(index)
                                            ? item
                                            : {
                                                  ...item,
                                                  product_video: {
                                                      ...item.product_video,
                                                      url: null,
                                                  },
                                              }
                                    }
                                />
                            ))}
                        </Slider>
                    </div>
                    {data?.primary?.button_text && (
                        <div className={TESTIMONIAL_BUTTON_CONTAINER}>
                            <NewPrimaryButtonWrapper
                                text={data?.primary?.button_text}
                                href={buttonHref}
                                section={
                                    SURVEY_START_SECTIONS?.FullyStyleInclusive
                                }
                                buttonId={BANNER_BUTTON_ID_TEXT}
                                className={CUSTOM_PRIMARY_BUTTON_CLASS}
                                event={
                                    GoogleTagManagerEvents.navigationInteractions
                                }
                                place={
                                    SURVEY_START_SECTIONS?.FullyStyleInclusive
                                }
                                menuName={
                                    SURVEY_START_SECTIONS?.FullyStyleInclusive
                                }
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default ShopTheLookCarrouselSection;
